import React, {useState} from 'react';
import PropTypes from 'prop-types';
import './style.scss';
const DATA_ID = 'data-id';
const SPACE_BAR = ' ';
const SPLIT_CHARACTER = '';
const IMG_TAG = 'img';

let onChangeWait = null;
/**
 * OverlaySlider:
 *  - Component display a string sequence
 *  - A set of adjecent characters in sequnce will be highlighted.
 *  - User can drag the higlighting left and right to select sequence of characters
 */
export function OverlaySlider(props) {
  const indexSize = props.highlight[1];
  const [startIndex, setStartIndex] = useState(props.highlight[0]);
  const [characterList] = useState(props.sequence.split(SPLIT_CHARACTER));

  const disableEvent = (event) => {
    var img = document.createElement(IMG_TAG);
    img.src = '';
    event.dataTransfer.setDragImage(img, 0, 0);
  };

  const dragOver = (event) => {
    event.preventDefault();
    const dataId = parseInt(event.target.getAttribute(DATA_ID));
    const startIndexLimit = props.sequence.length - indexSize;
    if (dataId > startIndexLimit) {
      setStartIndex(startIndexLimit);
    } else {
      setStartIndex(dataId);
    }
    setOnChange();
  };

  const setOnChange = () => {
    if (onChangeWait) {
      clearTimeout(onChangeWait);
    }
    onChangeWait = setTimeout(() => {
      props.onChange(getActiveSequence());
    }, props.onChangeTimeout);
  };

  const getActiveSequence = () => {
    let end = startIndex + indexSize;
    let text = props.sequence.substring(startIndex, end);
    return {
      text,
      start: startIndex,
      end,
    };
  };

  const listSequence = () => {
    let toHighlight = 0;
    let charTags = [];
    for (let ch in characterList) {
      const commonProps = {
        className: 'ov-slider__sequence--character',
        key: ch,
        draggable: false,
        onDragStart: disableEvent,
        onDragOver: dragOver,
        dataId: ch,
        character: characterList[ch],
      };
      if (ch == startIndex) {
        toHighlight = indexSize;
      }
      if (toHighlight > 0) {
        commonProps.draggable = !props.disable;
        commonProps.className =
          'ov-slider__sequence--selected ' + props.highlightClass;
        toHighlight -= 1;
      }
      charTags.push(<CharacterTag {...commonProps} />);
    }
    return charTags;
  };

  const sliderLabel = () => {
    if (props.label) {
      return <div className='ov-slider__label'>{props.label}</div>;
    } else return null;
  };

  return (
    <div className='overlay-slider'>
      <div className='ov-slider'>
        {sliderLabel()}
        <div className='ov-slider__sequence'>{listSequence()}</div>
      </div>
    </div>
  );
}

OverlaySlider.propTypes = {
  /**
   * The string sequence to be displayed.
   */
  sequence: PropTypes.string.isRequired,
  /**
   * Array containing the stand/end position for the highlight sequence
   */
  highlight: PropTypes.arrayOf(PropTypes.number).isRequired,
  /**
   * The string to set the color of highlighting
   */
  highlightClass: PropTypes.oneOf(['null', 'red', 'green', 'blue']),
  /**
   * The delay after which sliderChange event should be fired
   */
  onChangeTimeout: PropTypes.number,
  /**
   * Callback function to be executed when slider value changed
   */
  onChange: PropTypes.func.isRequired,
  /**
   * Boolean value specifying if slide is enable/disable
   */
  disable: PropTypes.bool,
  /**
   * Label for the slider
   */
  label: PropTypes.string,
};

OverlaySlider.defaultProps = {
  highlight: [0, 1],
  sequence: 'sequence',
  highlightClass: 'null',
  onChangeTimeout: 400,
  disable: false,
  label: '',
};

/**
 * CharacterTag
 *  - Component that display a single character of sequence in  OverlaySlider
 */
function CharacterTag(props) {
  const elementProps = (() => {
    const {className, draggable, onDragStart, onDragOver, dataId} = props;
    return {
      className,
      draggable,
      onDragStart,
      onDragOver,
      [DATA_ID]: dataId,
    };
  })();
  if (props.character === SPACE_BAR) {
    return (
      <span {...elementProps} onDrag={() => {}}>
        &nbsp;
      </span>
    );
  } else {
    return <span {...elementProps}>{props.character}</span>;
  }
}

CharacterTag.porpTypes = {
  /**
   * className to be set for the Character
   */
  className: PropTypes.string,
  /**
   * boolean value specifying if the character is draggable
   */
  draggable: PropTypes.bool,
  /**
   * callback function to execute when drag the character
   */
  onDragStart: PropTypes.func,
  /**
   * callback function to execute when draggedover the character
   */
  onDragOver: PropTypes.func,
  /**
   * The character to be displayed in the tag.
   */
  character: PropTypes.string,
  /**
   * The data-id value to be set on the character tag
   */
  dataId: PropTypes.number,
};
